<template>
  <v-row dense>
    <template v-if="!readonly">
      <v-col cols="6" :style="{ maxHeight }">
        <BAteTreeForm
          v-validate="validate"
          data-vv-as="«Дерево ATE»"
          :error="$errors.has(name)"
          :error-messages="$errors.first(name)"
          :name="name"
          :regions="regions"
          :municipalities="municipalities"
          :schools="schools"
          :model="model"
          :skeleton="skeleton"
          :max-height="maxHeight"
          :default-collapsed="defaultCollapsed"
          :height="maxHeight"
          multiple
          v-on="listeners"
        />
      </v-col>

      <v-divider vertical />
    </template>

    <v-col style="overflow-y: auto;">
      <BAteTreeForm
        :regions="regions"
        :municipalities="municipalities"
        :schools="schools"
        :model="model"
        readonly
        multiple
        :clearable="!readonly"
        :skeleton="skeleton"
        :default-collapsed="defaultCollapsed"
        :max-height="maxHeight"
        v-on="listeners"
      >
        <template #before-counts>
          <slot name="before-counts" />
        </template>
      </BAteTreeForm>
    </v-col>
  </v-row>
</template>

<script>
import uniqueId from 'lodash/uniqueId'
import BAteTreeForm from './BAteTree/BAteTreeForm.vue'


export default {
  name: 'BAteTree',
  inject: ['$validator'],
  components: {
    BAteTreeForm,
  },
  inheritAttrs: false,
  props: {
    skeleton: Boolean,
    validate: String,
    model: String,
    name: {
      type: String,
      default: () => uniqueId('b-ate-tree-'),
    },
    maxHeight: {
      type: String,
      default: '480px',
    },
    readonly: Boolean,
    regions: {
      type: Array,
      required: true,
    },
    municipalities: {
      type: Array,
      required: true,
    },
    schools: {
      type: Array,
      required: true,
    },
    /**
     * true, если дерево не должно быть раскрыто по умолчанию.
     */
    defaultCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listeners: this.$listeners || {},
    }
  },
}
</script>
